import ForTabs from 'components/digital-solutions/ForTabs'
import SectionTitle from 'components/global/SectionTitle'
import { Section } from 'components/grid'
import { CoreAdoptionContext } from 'context/CoreAdoption'
import React, { useContext } from 'react'
import { formatSectionId } from 'components/core-adoption/functions/formatSectionId'

export default function DigitalSolutionsTabs({ ...props }) {
	const { language, standard } = useContext(CoreAdoptionContext)
	const standardCapitalized = standard.toUpperCase() as 'CCSS' | 'TEKS'
	return (
		<Section margin="mt-20" id={formatSectionId(props)} className="scroll-mt-14">
			<SectionTitle title={language === 'english' ? 'Tools to Succeed in any Learning Environment' : 'Herramientas para triunfar en cualquier ambiente de aprendizaje'} />
			<ForTabs standard={standardCapitalized} language={language} />
		</Section>
	)
}
